export default "__VITE_ASSET__$mRJzcIH__"